var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.762,
    height: 14.174,
    viewBox: "0 0 15.762 14.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_750",
    "data-name": "Trac\\xE9 750",
    d: "M110.686,373.118l-5.531,6a.712.712,0,0,1-1.048,0l-5.531-6a3.67,3.67,0,0,1,.267-5.433,3.776,3.776,0,0,1,5.035.354l.5.5a.358.358,0,0,0,.5,0l.5-.5a3.776,3.776,0,0,1,5.035-.354A3.67,3.67,0,0,1,110.686,373.118Z",
    transform: "translate(-96.749 -365.925)",
    fill: "none",
    stroke: "#19c3b9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.40ab8d3d1aaebb5474383e4b6c5c69bf.svg";
export { ForwardRef as ReactComponent };